import React from "react";
import Table from "../../Common/Table";

import Permission from "../../Common/Permission";
import TableFields from "../../../constants/UserProperty/TableFields.json";
import { getPath } from "../../../utils";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const PropertiesList = ({ handleClick, userPropertyList }) => {
  const allActions = MenuActionsMappings[MenuNames.USER_PROPERTY];

  const getFieldValue = (property, key) => {
    switch (key) {
      case "actions":
        return (
          <Permission
            optionalPerms={[allActions.UPDATE]}
            notAllowedText="No Actions Allowed"
          >
            <span
              onClick={() => handleClick("Edit", property.id)}
              className={"edit-options cursor-pointer"}
            >
              View/Edit
            </span>
          </Permission>
        );
      default:
        return getPath(property, key, "NA");
    }
  };

  return (
    <Permission requiredPerms={[allActions.READ]}>
      <Table
        list={userPropertyList}
        getFieldValue={getFieldValue}
        fields={TableFields}
      />
    </Permission>
  );
};

export default PropertiesList;
